import { TwitterUserInfo } from './TwitterUserInfo';

export function TwitterPhoto({ username, className = '', fallback = null }: { username: string; className?: string; fallback?: React.ReactNode }) {
    return (
        <TwitterUserInfo username={username}>
            {(twitterUserInfo, isLoaded) => {
                if (isLoaded && !twitterUserInfo) return <>{fallback}</>;

                return (
                    <div className='w-full h-full'>
                        <img
                            className={`w-full h-full object-cover ${!isLoaded ? 'blur-sm' : ''} ${className}`}
                            src={twitterUserInfo?.profilePicture}
                            alt='Twitter Avatar'
                            loading='lazy'
                            decoding='async'
                        />
                    </div>
                );
            }}
        </TwitterUserInfo>
    );
}
